import React, { useEffect, useState } from 'react';

import { Button, Tooltip } from 'antd';
import { useSelector } from 'react-redux';

import { PrivateWrapper } from '../../../PrivateWrapper';

import { Lock } from '../../../assets/icons';
import AuthForm from '../../../components/AuthForm/AuthForm';
import AuthInfo from '../../../components/AuthInfo/AuthInfo';

import StepFive from './StepFive';
import StepFour from './StepFour';
import StepOne from './StepOne';
import StepSix from './StepSix';
import StepThree from './StepThree';
import StepTwo from './StepTwo';

import './Verification.scss';

const Verification = () => {
  const [activeStep, setActiveStep] = useState('StepOne');
  const [viewForm, setViewForm] = useState(false);
  const counter = useSelector((state) => state.userData.counter);
  const userData = useSelector((state) => state.userData);

  useEffect(() => {
    if (counter.toString() === '5' && !userData?.userData?.isKYCVerified) {
      setActiveStep('StepSix');
      return;
    }
    switch (counter.toString()) {
      case '0': {
        setActiveStep('StepOne');
        break;
      }
      case '1': {
        setActiveStep('StepTwo');
        break;
      }
      case '2': {
        setActiveStep('StepThree');
        break;
      }
      case '3': {
        setActiveStep('StepFour');
        break;
      }
      case '4': {
        setActiveStep('StepFive');
        break;
      }
      case '5': {
        setActiveStep('StepSix');
        break;
      }
      default: {
        setActiveStep('StepOne');
        break;
      }
    }
  }, []);
  let infoDescription, infoTitle, formTitle, formDescription;
  if (activeStep === 'StepOne') {
    formTitle = <>Verify your identity</>;
  }
  if (activeStep === 'StepTwo') {
    formTitle = <>Provide your contact information</>;
  }
  if (activeStep === 'StepThree') {
    formTitle = <>What’s your Social Security Number?</>;
    formDescription = (
      <>
        We are required by federal law to ask for your Social Security Number. We will use your SSN for tax reporting. Your information is encrypted
        and secure.
      </>
    );
  }
  if (activeStep === 'StepOne' || 'StepTwo' || 'StepThree') {
    infoTitle = <>Set up your account</>;
    infoDescription = (
      <>
        <p>
          Let’s get your{' '}
          <Tooltip
            placement='bottom'
            title='A brokerage account holds your financial assets (cash and property shares) on your behalf. Realbricks does not charge any fee on these accounts, nor does it offer any annual percentage yield. They are subject to ordinary income tax rates and capital gains taxes.'
          >
            <span className='underline cursor-pointer'>brokerage account</span>
          </Tooltip>{' '}
          set up so that you can begin investing on Realbricks.
        </p>
        <p>
          We are required by federal law to verify the identity of any person creating an account to purchase shares. Realbricks complies with all{' '}
          <Tooltip
            placement='bottom'
            title={
              <>
                The United States Securities and Exchange Commission (SEC) is an independent agency of the United States federal government. The SEC
                protects investors, promotes fairness in the securities markets, and shares information about companies and investment professionals
                to help investors make informed decisions and invest with confidence. Learn more at:{' '}
                <a style={{ color: '#2457C5' }} href='https://www.sec.gov/'>
                  https://www.sec.gov/
                </a>
              </>
            }
          >
            <span className='underline cursor-pointer'>SEC</span>
          </Tooltip>{' '}
          and{' '}
          <Tooltip
            placement='bottom'
            title={
              <>
                The Financial Industry Regulatory Authority (FINRA) is a private American corporation that acts as a self-regulatory organization that
                regulates member brokerage firms and exchange markets. FINRA is dedicated to protecting investors and safeguarding market integrity in
                a manner that facilitates vibrant capital markets. Learn more at:{' '}
                <a style={{ color: '#2457C5' }} href='https://www.finra.org/about'>
                  {' '}
                  https://www.finra.org/about
                </a>
              </>
            }
          >
            <span className='underline cursor-pointer'>FINRA</span>
          </Tooltip>{' '}
          customer identification rules.
        </p>
      </>
    );
  }
  if (activeStep === 'StepFour') {
    infoTitle = <>Your investment history</>;
    infoDescription = <>Tell us a little about your investing experience and any conflicts of interest you might have. </>;
    formTitle = <>Accredited investor check</>;
    formDescription = <>Select any of the statements that apply to you. You can still invest even if none apply to you.</>;
  }
  if (activeStep === 'StepFive') {
    infoTitle = <>Review investor agreements</>;
    infoDescription = <>Please review these agreements, which cover important details about the services we offer.</>;
    formTitle = <>Account application agreement</>;
    formDescription = <>This includes links to important documents and explains how Realbricks markets works.</>;
  }
  if (activeStep === 'StepSix') {
    infoTitle = <>Review your information</>;
    infoDescription = (
      <>Please take a moment to ensure all your information has been entered correctly before opening your brokerage account with Realbricks.</>
    );
  }

  return (
    <PrivateWrapper>
      <div className='auth'>
        <AuthInfo
          className={viewForm ? 'hide' : null}
          title={infoTitle}
          description={infoDescription}
          note={
            <>
              <Lock marginRight='10px' />
              <span className='fw-400'>All of your information is encrypted and secure.</span>
            </>
          }
        >
          <div className='mobile-action' onClick={() => setViewForm(true)}>
            <Button className='w-100'>Get Started</Button>
          </div>
        </AuthInfo>
        <AuthForm className={viewForm ? 'show' : null} title={formTitle} description={formDescription}>
          <>
            <div className={`progress-bar ${activeStep.toLowerCase()}`} />
            {activeStep === 'StepOne' && <StepOne nextAction={setActiveStep} />}
            {activeStep === 'StepTwo' && <StepTwo nextAction={setActiveStep} />}
            {activeStep === 'StepThree' && <StepThree nextAction={setActiveStep} />}
            {activeStep === 'StepFour' && <StepFour nextAction={setActiveStep} />}
            {activeStep === 'StepFive' && <StepFive nextAction={setActiveStep} />}
            {activeStep === 'StepSix' && <StepSix nextAction={setActiveStep} />}
          </>
        </AuthForm>
      </div>
    </PrivateWrapper>
  );
};

export default Verification;
